import RouterView from '@/page/main/DefaultRouterView'
import CarList from '@/page/car/list'

import UseApply from '@/page/car/useApply'
import UseList from '@/page/car/useList'

import RepairApply from '@/page/car/repairApply'
import AcceptApply from '@/page/car/acceptApply'
import RepairList from '@/page/car/repairList'

import DispatchApply from '@/page/car/dispatchApply'
import DispatchList from '@/page/car/dispatchList'

import ControlApply from '@/page/car/controlApply'
import ControlList from '@/page/car/controlList'

import RewardsApply from '@/page/car/rewardsApply'
import RewardsList from '@/page/car/rewardsList'

import BuyApply from '@/page/car/buyApply'
import BuyList from '@/page/car/buyList'

export default {
  path: '/Car',
  component: RouterView,
  children: [{
    path: 'List',
    meta: {
      type: ['car', 'carList'],
      title: '车辆列表'
    },
    component: CarList
  }, {
    path: 'UseApply',
    meta: {
      type: ['car', 'useCarList'],
      title: '车辆使用申请'
    },
    component: UseApply
  }, {
    path: 'UseList',
    meta: {
      type: ['car', 'useCarList'],
      title: '车辆使用申请列表'
    },
    component: UseList
  }, {
    path: 'RepairApply',
    meta: {
      type: ['car', 'repairCarList'],
      title: '车辆维修申请'
    },
    component: RepairApply
  }, {
    path: 'AcceptApply',
    meta: {
      type: ['car', 'repairCarList'],
      title: '车辆维修完毕验收申请'
    },
    component: AcceptApply
  }, {
    path: 'RepairList/:listType?',
    meta: {
      type: ['car', 'repairCarList'],
      title: '车辆维修列表'
    },
    component: RepairList
  }, {
    path: 'DispatchApply',
    meta: {
      type: ['car', 'dispatchCarList'],
      title: '车辆派遣申请'
    },
    component: DispatchApply
  }, {
    path: 'DispatchList',
    meta: {
      type: ['car', 'dispatchCarList'],
      title: '车辆派遣申请列表'
    },
    component: DispatchList
  }, {
    path: 'ControlApply',
    meta: {
      type: ['car', 'controlCarList'],
      title: '车辆调度申请'
    },
    component: ControlApply
  }, {
    path: 'ControlList',
    meta: {
      type: ['car', 'controlCarList'],
      title: '车辆调度申请列表'
    },
    component: ControlList
  }, {
    path: 'RewardsApply',
    meta: {
      type: ['car', 'rewardsCarList'],
      title: '车辆管理奖惩审批'
    },
    component: RewardsApply
  }, {
    path: 'RewardsList',
    meta: {
      type: ['car', 'rewardsCarList'],
      title: '车辆管理奖惩审批列表'
    },
    component: RewardsList
  }, {
    path: 'BuyApply',
    meta: {
      type: ['car', 'buyCarList'],
      title: '车辆购置申请'
    },
    component: BuyApply
  }, {
    path: 'BuyList',
    meta: {
      type: ['car', 'buyCarList'],
      title: '车辆购置申请列表'
    },
    component: BuyList
  }, ]
}


// WEBPACK FOOTER //
// ./src/router/car.js